const focusInput = (element) => {
  ($(element).is(":input") ? $(element) : $(element).find(":input")).focus()
}

export default {
  name: "autoFocus",
  inserted(el) {
    _.defer(() => {
      focusInput(el)
    })
  }
}



// WEBPACK FOOTER //
// ./src/directives/auto-focus.js